// extracted by mini-css-extract-plugin
export var askAiIcon = "_qb-9";
export var container = "_qb-0";
export var groupSeparator = "_qb-a";
export var highlight = "_qb-4";
export var resultIcon = "_qb-5";
export var resultItem = "_qb-7";
export var resultSubtitle = "_qb-3";
export var resultTitle = "_qb-2";
export var resultsList = "_qb-1";
export var searchGroup = "_qb-6";
export var selected = "_qb-8";